import styled from '@emotion/styled';

export const Socials = styled.div`
  display: flex;
  text-align: left;
  margin-bottom: 23px;
  & svg:nth-of-type(1) {
    margin-right: 15px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 30px;
  text-align: left;

  @media (max-width: ${props => props.theme.breakpoints.l}) {
  }

  img {
    cursor: pointer;
  }
`;
